export default "__VITE_ASSET__1IcZ3LLU__"